import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Calendar, TrendingUp, Zap } from 'lucide-react';

const TrialExpired = ({ tradeCount = 0, trialStartDate }) => {
  const navigate = useNavigate();

  const formattedDate = trialStartDate
    ? new Date(trialStartDate).toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
    : null;

  return (
    <div
      style={{
        minHeight: 'calc(100vh - 120px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 16px',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '480px',
          textAlign: 'center',
        }}
      >
        {/* Icon */}
        <div
          style={{
            width: '72px',
            height: '72px',
            borderRadius: '50%',
            background: 'var(--danger-bg)',
            border: '1px solid var(--danger)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
          }}
        >
          <Lock size={32} style={{ color: 'var(--danger)' }} />
        </div>

        {/* Heading */}
        <h1
          style={{
            fontSize: 'clamp(20px, 5vw, 26px)',
            fontWeight: 800,
            color: 'var(--text-primary)',
            marginBottom: '10px',
            lineHeight: 1.3,
          }}
        >
          Your 7-day Pro trial has ended
        </h1>

        {/* Subtext */}
        <p
          style={{
            fontSize: '15px',
            color: 'var(--text-secondary)',
            marginBottom: '28px',
            lineHeight: 1.6,
          }}
        >
          Upgrade to Pro to continue your trading journey.
        </p>

        {/* Summary card */}
        <div
          style={{
            background: 'var(--bg-card)',
            border: '1px solid var(--border)',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '28px',
            textAlign: 'left',
          }}
        >
          <p
            style={{
              fontSize: '11px',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              color: 'var(--text-muted)',
              marginBottom: '14px',
            }}
          >
            Trial Summary
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div
                style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '8px',
                  background: 'var(--accent-subtle)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <TrendingUp size={18} style={{ color: 'var(--accent)' }} />
              </div>
              <div>
                <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '2px' }}>
                  Trades logged during trial
                </p>
                <p style={{ fontSize: '18px', fontWeight: 800, color: 'var(--text-primary)' }}>
                  {tradeCount} {tradeCount === 1 ? 'trade' : 'trades'}
                </p>
              </div>
            </div>

            {formattedDate && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div
                  style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '8px',
                    background: 'var(--accent-subtle)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <Calendar size={18} style={{ color: 'var(--accent)' }} />
                </div>
                <div>
                  <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '2px' }}>
                    Trial started on
                  </p>
                  <p style={{ fontSize: '15px', fontWeight: 700, color: 'var(--text-primary)' }}>
                    {formattedDate}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <button
            onClick={() => navigate('/pricing')}
            style={{
              width: '100%',
              padding: '14px 24px',
              borderRadius: '10px',
              border: 'none',
              background: 'var(--accent)',
              color: 'var(--bg)',
              fontSize: '15px',
              fontWeight: 800,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
            }}
          >
            <Zap size={18} />
            Upgrade to Pro — ₹999/month
          </button>

          <button
            onClick={() => navigate('/pricing')}
            style={{
              width: '100%',
              padding: '13px 24px',
              borderRadius: '10px',
              border: '1px solid var(--border)',
              background: 'var(--bg-card)',
              color: 'var(--text-primary)',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            View All Plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrialExpired;
